import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes
} from 'react-router-dom';

import { GoogleOAuthProvider } from '@react-oauth/google';

import { getHost, getUserInSession } from 'store/user-actions';

import Layout from 'components/Layout/Layout';
import Store from 'pages/Store/Store';
import Login from 'pages/Login/Login';
import CreateAcademy from 'pages/CreateAcademy/CreateAcademy';
import MyPortfolio from 'pages/MyPortfolio/MyPortfolio';
import Treasury from 'pages/Treasury/Treasury';
import MyAccount from 'pages/MyAccount/MyAccount';
import Campus from 'pages/Campus/Campus';
import Academy from 'pages/Academy/Academy';
import Course from 'pages/Course/Course';
import Book from 'pages/Book/Book';
import Verified from 'pages/Verified/Verified';
import VerifiedDegree from 'pages/VerifiedDegree/VerifiedDegree';
import Invite from 'pages/Invite/Invite';
import Product from 'pages/Product/Product';
import UDCProduct from 'pages/UDCProduct/UDCProduct';
import Chat from 'pages/Chat/Chat';
import UDCPreregister from 'pages/UDCPreregister/UDCPreregister';
import RecoverAccount from 'pages/RecoverAccount/RecoverAccount';
import Register from 'pages/Register/Register';
import LoginUDC from 'pages/LoginUDC/LoginUDC';
import Evaluator from 'pages/Evaluator/Evaluator';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const urlNew = window.location.host;
    dispatch(getUserInSession(0));
    dispatch(getHost(urlNew));
  }, [dispatch]);

  return (
    <Router>
      <GoogleOAuthProvider clientId="452748709064-68oatlrd4aiau0md74363knvj4rg43ke.apps.googleusercontent.com">
        <Layout>
          <Routes>
            <Route exact path="/" element={<Store />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/loginUDC" element={<LoginUDC />} />
            <Route
              exact
              path="/myPortfolio"
              element={<MyPortfolio />}
            />
            <Route exact path="/store" element={<Store />} />
            <Route
              exact
              path="/campus/:section"
              element={<Campus />}
            />
            <Route
              exact
              path="/academy/:academyName"
              element={<Academy />}
            />
            <Route
              exact
              path="/course/:academyName/:idCourse"
              element={<Course />}
            />
            <Route
              exact
              path="/store/:idSection"
              element={<Store />}
            />
            <Route
              exact
              path="/createAcademy"
              element={<CreateAcademy />}
            />
            <Route exact path="/treasury" element={<Treasury />} />
            <Route
              exact
              path="/myAccount/:section"
              element={<MyAccount />}
            />
            <Route exact path="/book/:book" element={<Book />} />
            <Route exact path="/verified" element={<Verified />} />
            <Route
              exact
              path="/diploma/verified/:idCampus/:idCourse/:idUserProgress"
              element={<VerifiedDegree />}
            />
            <Route
              exact
              path="/invite/:idGroup"
              element={<Invite />}
            />
            <Route
              exact
              path="/product/:productType/:academyName/:idProduct"
              element={<Product />}
            />
            <Route
              exact
              path="/product/:productType/:idProduct"
              element={<UDCProduct />}
            />
            <Route exact path="/chat" element={<Chat />} />
            <Route
              exact
              path="/preregister"
              element={<UDCPreregister />}
            />
            <Route
              exact
              path="/preregister/:section"
              element={<UDCPreregister />}
            />
            <Route
              exact
              path="/preregister"
              element={<Navigate to="/preregister/landing" />}
            />
            <Route
              exact
              path="/inscripciones"
              element={<Navigate to="/preregister/landing" />}
            />
            <Route
              exact
              path="/recoverAccount"
              element={<RecoverAccount />}
            />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/evaluator" element={<Evaluator />} />
            <Route
              exact
              path="/evaluator/:idActivity"
              element={<Evaluator />}
            />
          </Routes>
        </Layout>
      </GoogleOAuthProvider>
    </Router>
  );
}

export default App;
